if (!customElements.get('plush-localization-form')) {
  customElements.define(
    'plush-localization-form',
    class PlushLocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]',
          ),
          button: this.querySelector('button.localization-form__select'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.elements.button.addEventListener(
          'click',
          this.openSelector.bind(this),
        );

        this.querySelectorAll('a').forEach((item) =>
          item.addEventListener('click', this.onItemClick.bind(this)),
        );
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }
    },
  );
}
